import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AppsOutageIcon(props: IconProps) {
    return <Icon {...props} iconKey={"apps_outage"}/>
}
